import React, { useState, useEffect } from 'react';
import { X, Loader2 } from 'lucide-react';
import { RichTextEditor } from '../RichTextEditor';
import { formatDescriptionHtml } from './JobHelpers';

export function EditDescriptionModal({ isOpen, onClose, description, onSubmit, loading }) {
  const initDesc = (() => {
    if (!description) return '';
    let d = description.description || '';
    if (d && !/<(p|ol|ul|li|h[1-6]|div|br|blockquote)\b/i.test(d)) {
      d = d.split('\n').filter(Boolean).map(line => `<p>${line}</p>`).join('');
    } else if (d) {
      d = formatDescriptionHtml(d);
    }
    return d;
  })();
  const [formData, setFormData] = useState({ job_title: description?.job_title || '', description: initDesc });
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl">
        <div className="p-4 border-b"><h2 className="font-semibold">Edit description</h2></div>
        <form onSubmit={e => { e.preventDefault(); onSubmit(formData); }} className="p-6 space-y-4">
          <div><label className="block text-xs text-slate-500 uppercase mb-1">Job Title</label><input type="text" value={formData.job_title} onChange={e => setFormData({...formData, job_title: e.target.value})} className="w-full px-3 py-2 border rounded text-sm" data-testid="edit-job-title" /></div>
          <div><label className="block text-xs text-slate-500 uppercase mb-1">Description</label>
            <RichTextEditor value={formData.description} onChange={(val) => setFormData({...formData, description: val})} placeholder="Enter job description..." />
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded">Cancel</button>
            <button type="submit" disabled={loading} className="px-4 py-2 text-sm bg-blue-500 text-white rounded flex items-center gap-2" data-testid="edit-job-submit">{loading && <Loader2 size={16} className="animate-spin" />}Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// === ADD ASSIGNEE MODAL ===
